import { z } from 'zod';
import { uuid } from './primitives.js';
export const completionSchemaSchema = z.object({
    id: uuid,
    gameId: uuid,
    trophySetId: uuid,
});
/** Eine Section ist Base Game oder genau eine DLC-Trophy-Group. */
export const completionSectionSchema = z.object({
    id: uuid,
    schemaId: uuid,
    trophyGroupId: uuid.nullable(),
    title: z.string().min(1),
    order: z.number().int().nonnegative(),
    kind: z.enum(['base', 'dlc']),
});
export const completionCategorySchema = z.object({
    id: uuid,
    sectionId: uuid,
    title: z.string().min(1),
    order: z.number().int().nonnegative(),
});
export const progressTypeSchema = z.enum(['boolean', 'counter', 'percentage']);
export const completionModeSchema = z.enum(['manual', 'trophy', 'roadmap']);
export const progressContributionTypeSchema = z.enum(['proportional', 'binary', 'fixed_weight']);
export const completionItemSchema = z.object({
    id: uuid,
    categoryId: uuid,
    title: z.string().min(1),
    order: z.number().int().nonnegative(),
    progressType: progressTypeSchema,
    target: z.number().nonnegative(),
    completionMode: completionModeSchema,
    progressContributionType: progressContributionTypeSchema,
    weight: z.number().positive().default(1),
    missable: z.boolean(),
});
export const completionItemTrophySchema = z.object({ itemId: uuid, trophyId: uuid });
export const completionItemRoadmapStepSchema = z.object({ itemId: uuid, roadmapStepId: uuid });
export const completionItemMapLinkSchema = z.object({
    itemId: uuid,
    vmapsTargetId: z.string().min(1),
    label: z.string().nullable(),
});
/** Nutzerfortschritt je Completion Item. User-Daten. */
export const userCompletionProgressSchema = z.object({
    userGameRunId: uuid,
    itemId: uuid,
    current: z.number().nonnegative(),
});
//# sourceMappingURL=completion.js.map